
const fields = [
  {
    type: 'bsx-label',
    label: 'ID',
    model: 'id',
    visible: (model) => model.id,
  },
  {
    type: 'bsx-label',
    inputType: 'text',
    label: '科別',
    model: 'name',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-toggle',
    label: '是否支援網路掛號',
    model: 'support_online_registration',
    required: true,
    textOn: '是',
    textOff: '否',
  },
  {
    type: "x-QuillEditor",
    label: "掛號說明",
    model: "no_online_consultation",
    required: true,
    help: "顯示於網路掛號服務中無法網掛的科別",
    visible: (model) => !model.support_online_registration,
    validator: function () {
      this.validation();
    },
  }
];

export default fields;
